import React, { useMemo } from "react";
import CustomCarrusel from "@components/custom-carrusel";
import { IArticlesCardComponent } from "shared/models/interfaces/components/article-card.interface";
import ArticleCard from "@components/article-card";
import { TitleThickThin } from "@components/titles";
import { styled } from "@mui/material/styles";
import { useTranslations } from "next-intl";
import { Grid } from "@mui/material";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";
import useBlogPosts from "custom-hooks/use-blog-posts.hook";

const Wrapper = styled("div")({
  width: "90%",
  margin: "auto",
});

const ContentSection = styled(Grid)(({ theme }) => ({
  position: "relative",
  backgroundColor: "var(--color-brand-cream-primary)",
  padding: "5rem 4rem ",
  rowGap: "2rem",
  "@media screen and (max-width: 768px)": {
    padding: "2rem 1rem ",
  },
}));

function ArticlesBlogHomeSection() {
  const titles = useTranslations("home.recentArticles");
  const { data: blogPosts, isLoading, error } = useBlogPosts();

  const articlesTitle = titles("title") || "";
  const [title, ...rest] = articlesTitle.split(" ");

  // Map API response to component interface
  const articles: IArticlesCardComponent[] = useMemo(() => {
    if (isLoading || error) {
      return fallbackArticles;
    }

    if (!Array.isArray(blogPosts) || blogPosts.length === 0) {
      return fallbackArticles;
    }

    return (
      blogPosts
        ?.filter((post) => post?.title && post?.excerpt && post?.url)
        .map((post) => ({
          title: post.title,
          extract: post.excerpt,
          link: post.url,
          img: post.image,
        })) || fallbackArticles
    );
  }, [blogPosts]);

  if (isLoading) {
    return <div>Cargando artículos...</div>;
  }

  if (error) {
    <section>
      <ContentSection container>
        <Grid item xs={12}>
          <WsSectionTitleWithThinTitle
            title={title}
            subtitle={rest.join(" ")}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomCarrusel>
            {fallbackArticles.map((article, i) => (
              <ArticleCard key={i} {...article}></ArticleCard>
            ))}
          </CustomCarrusel>
        </Grid>
      </ContentSection>
    </section>;
  }

  return (
    <section>
      <ContentSection container>
        <Grid item xs={12}>
          <WsSectionTitleWithThinTitle
            title={title}
            subtitle={rest.join(" ")}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomCarrusel>
            {articles.map((article, i) => (
              <ArticleCard key={i} {...article}></ArticleCard>
            ))}
          </CustomCarrusel>
        </Grid>
      </ContentSection>
    </section>
  );
}

export default ArticlesBlogHomeSection;

const fallbackArticles: IArticlesCardComponent[] = [
  {
    title: "¿Cómo saber qué casa comprar?",
    extract: `Ponemos a tu disposición documentación verificada y validada por profesionales del sector inmobiliario, que te ayudará a saber qué casa comprar.`,
    link: "https://blog.remaxrd.com/finanzas/como-saber-que-casa-comprar/",
    img: "https://blog.remaxrd.com/wp-content/uploads/2022/07/Como-saber-que-casa-comprar.png",
  },
  {
    title:
      "¿Cuáles son los requisitos para recibir el Bono de Primera Vivienda?",
    extract: `Te explicamos los requisitos a completar, para recibir el bono de primera vivienda y puedas cumplir una de las metas más importantes de tu vida.`,
    link: "https://blog.remaxrd.com/sector-inmobiliario/cuales-son-los-requisitos-para-recibir-el-bono-de-primera-vivienda/",
    img: "https://blog.remaxrd.com/wp-content/uploads/2022/06/portada-blog.png",
  },
  {
    title: "¿Cómo conseguir un préstamo hipotecario? Te mostramos",
    extract: `Te mostramos los requisitos y recomendaciones para que puedas conseguir la aprobación de un préstamo hipotecario, de forma fácil y segura.`,
    link: "https://blog.remaxrd.com/sector-inmobiliario/como-conseguir-un-prestamo-hipotecario-te-mostramos/",
    img: "https://blog.remaxrd.com/wp-content/uploads/2022/07/%C2%BFComo-conseguir-un-prestamo-hipotecario.png",
  },
  {
    title: "¿Cómo mejorar tu historial crediticio para financiar tu casa?",
    extract: `Para poder conseguir un préstamos, hay diversos factores que se toman en cuenta. ¿El más importante? Mejorar tu historial crediticio o score crediticio.`,
    link: "https://blog.remaxrd.com/finanzas/como-mejorar-tu-historial-crediticio-para-financiar-tu-casa/",
    img: "https://blog.remaxrd.com/wp-content/uploads/2022/07/portada-blog-historial-crediticio.png",
  },
];
